import {vnModule_knockoutJS} from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";

import {XMLHttpRequestHandler} from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {XMLHttpRequestHandler_requestType} from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {vn_app_zone_notification} from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";
import {accountingReportByAccount_template} from "../components/templates/accountingReportByAccount_template";
import {downloadCSV} from "../../vendor/valnet/valnet_jslib/vnHelpers/helper_functions";
import {header} from "./header";

declare var ko: any;
declare var page: any;

export class accounting_report_by_account extends vnModule_knockoutJS {

    protected XHRHdl: XMLHttpRequestHandler;
    protected elementsList: accountingReportByAccount_template;

    protected getModuleName() {
        return "accounting_report_by_account";
    }

    buildContent(): Array<Element> {
        this.elementsList = new accountingReportByAccount_template("list", this.viewModel, this);
        let zoneHeader = this.getVnAppZone().app.getZoneByName("Header");
        let loadedModule = zoneHeader.loadedModule;
        (<header>loadedModule).setHeaderTitle("Accounting Report By Account");
        return [this.elementsList.build()];
    }

    public fillPage(): void {
        this.getfilterReference();
    }

    protected paginationOnPageClick() {
        this.filterList();
    }

    protected filterSimpleOnChange() {
        this.filterList();
    }

    protected filterSimpleCancel(){

    }

    protected paymentListReorder() {
        this.filterList();
    }

    protected filterList() {

        // LOADING : starts
        this.elementsList.builtTemplate.classList.add("loading");

        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }

        let subViewModel = this.elementsList.getViewModelForRequest();
        let usrReq_url: string;

        usrReq_url = '/api/accounting/getReport/';
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onFilterRequestReturn;
        this.XHRHdl.execute();
    }

    protected onFilterRequestReturn(req, obj) {

        return function () {

            if (req.request.readyState == 4) {

                let responseParsed = JSON.parse(req.request.response);

                if (req.request.status == 200) {
                    console.log(responseParsed.data)
                    obj.updateList(responseParsed.data);

                } else if (req.request.status == "423") {
                    obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_WARNING, responseParsed.message);
                    obj.getVnAppZone().showNotificationToModule();
                    page.redirect('/' + obj.getVnAppZone().app.params.idBrand + '/home');
                } else {
                    //obj.onUpdateError(req.request.status, responseParsed);

                    obj.elementsList.validationsList.setSingleMessage({
                        field: "error",
                        label: req.request.status,
                        message: responseParsed.message
                    });
                    window.scrollTo(0, 0);
                }

                // LOADING : ends
                obj.elementsList.builtTemplate.classList.remove("loading");
            }
        }
    }

    protected getfilterReference() {

        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }

        let usrReq_url: string;

        usrReq_url = '/api/transactions/references';

        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push();
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        let localCheck = this.XHRHdl.requestId;
        let _myThis = this;
        setTimeout(function () {

            if (localCheck == _myThis.XHRHdl.requestId) {
                _myThis.XHRHdl.onReadyStateFunction = _myThis.onGetfilterReferenceRequestReturn;
                _myThis.XHRHdl.execute();
            }
        }, 400);
    }

    protected onGetfilterReferenceRequestReturn(req, obj) {

        return function () {

            obj.manageResponse(req, obj, function(){

                let responseParsed = JSON.parse(req.request.response);
                obj.updateReferenceList(responseParsed.data);
                obj.filterList();
            })
        }
    }

    protected updateReferenceList(responseParsed: any) {

        this.elementsList.setAccounts(responseParsed.accounts);
        this.elementsList.setCompanies(responseParsed.companies);
    }

    //
    // update the module list using the objects list
    protected updateList(responseParsed) {
        let huit_neuf_this = this.elementsList;
        let _this = this;

        if (responseParsed.brandsData && responseParsed.brandsData.length > 0) {
            let totalCostCAD = 0;
            let totalCostUSD = 0;
            let totalCostGBP = 0;
            let totalCostEUR = 0;
            for (let brandData of responseParsed.brandsData) {

                for (let item of brandData.totalCosts) {
                    totalCostCAD += Number(item["totalCostsCAD"]);
                    totalCostUSD += Number(item["totalCostsUSD"]);
                    totalCostGBP += Number(item["totalCostsGBP"]);
                    totalCostEUR += Number(item["totalCostsEUR"]);
                    item["commissionCostCAD"] = '' + Number(item["commissionCostCAD"]).toLocaleString(undefined, {minimumFractionDigits: 2});
                    item["commissionCostUSD"] = '' + Number(item["commissionCostUSD"]).toLocaleString(undefined, {minimumFractionDigits: 2});
                    item["commissionCostGBP"] = '' + Number(item["commissionCostGBP"]).toLocaleString(undefined, {minimumFractionDigits: 2});
                    item["commissionCostEUR"] = '' + Number(item["commissionCostEUR"]).toLocaleString(undefined, {minimumFractionDigits: 2});
                    item["performanceCostCAD"] = '' + Number(item["performanceCostCAD"]).toLocaleString(undefined, {minimumFractionDigits: 2});
                    item["performanceCostUSD"] = '' + Number(item["performanceCostUSD"]).toLocaleString(undefined, {minimumFractionDigits: 2});
                    item["performanceCostGBP"] = '' + Number(item["performanceCostGBP"]).toLocaleString(undefined, {minimumFractionDigits: 2});
                    item["performanceCostEUR"] = '' + Number(item["performanceCostEUR"]).toLocaleString(undefined, {minimumFractionDigits: 2});
                    item["consultingBaseCostCAD"] = '' + Number(item["consultingBaseCostCAD"]).toLocaleString(undefined, {minimumFractionDigits: 2});
                    item["consultingBaseCostUSD"] = '' + Number(item["consultingBaseCostUSD"]).toLocaleString(undefined, {minimumFractionDigits: 2});
                    item["consultingBaseCostGBP"] = '' + Number(item["consultingBaseCostGBP"]).toLocaleString(undefined, {minimumFractionDigits: 2});
                    item["consultingBaseCostEUR"] = '' + Number(item["consultingBaseCostEUR"]).toLocaleString(undefined, {minimumFractionDigits: 2});
                    item["taxesCostCAD"] = '' + Number(item["taxesCostCAD"]).toLocaleString(undefined, {minimumFractionDigits: 2});
                    item["taxesCostUSD"] = '' + Number(item["taxesCostUSD"]).toLocaleString(undefined, {minimumFractionDigits: 2});
                    item["taxesCostGBP"] = '' + Number(item["taxesCostGBP"]).toLocaleString(undefined, {minimumFractionDigits: 2});
                    item["taxesCostEUR"] = '' + Number(item["taxesCostEUR"]).toLocaleString(undefined, {minimumFractionDigits: 2});
                    item["totalCostsCAD"] = '' + Number(item["totalCostsCAD"]).toLocaleString(undefined, {minimumFractionDigits: 2});
                    item["totalCostsUSD"] = '' + Number(item["totalCostsUSD"]).toLocaleString(undefined, {minimumFractionDigits: 2});
                    item["totalCostsGBP"] = '' + Number(item["totalCostsGBP"]).toLocaleString(undefined, {minimumFractionDigits: 2});
                    item["totalCostsEUR"] = '' + Number(item["totalCostsEUR"]).toLocaleString(undefined, {minimumFractionDigits: 2});
                    item["tipsCostCAD"] = '' + Number(item["tipsCostCAD"]).toLocaleString(undefined, {minimumFractionDigits: 2});
                    item["tipsCostUSD"] = '' + Number(item["tipsCostUSD"]).toLocaleString(undefined, {minimumFractionDigits: 2});
                    item["tipsCostGBP"] = '' + Number(item["tipsCostGBP"]).toLocaleString(undefined, {minimumFractionDigits: 2});
                    item["tipsCostEUR"] = '' + Number(item["tipsCostEUR"]).toLocaleString(undefined, {minimumFractionDigits: 2});
                    item["bonusCostCAD"] = '' + Number(item["bonusCostCAD"]).toLocaleString(undefined, {minimumFractionDigits: 2});
                    item["bonusCostUSD"] = '' + Number(item["bonusCostUSD"]).toLocaleString(undefined, {minimumFractionDigits: 2});
                    item["bonusCostGBP"] = '' + Number(item["bonusCostGBP"]).toLocaleString(undefined, {minimumFractionDigits: 2});
                    item["bonusCostEUR"] = '' + Number(item["bonusCostEUR"]).toLocaleString(undefined, {minimumFractionDigits: 2});
                    item["hostingCostCAD"] = '' + Number(item["hostingCostCAD"]).toLocaleString(undefined, {minimumFractionDigits: 2});
                    item["hostingCostUSD"] = '' + Number(item["hostingCostUSD"]).toLocaleString(undefined, {minimumFractionDigits: 2});
                    item["hostingCostGBP"] = '' + Number(item["hostingCostGBP"]).toLocaleString(undefined, {minimumFractionDigits: 2});
                    item["hostingCostEUR"] = '' + Number(item["hostingCostEUR"]).toLocaleString(undefined, {minimumFractionDigits: 2});
                    item["trainingCostCAD"] = '' + Number(item["trainingCostCAD"]).toLocaleString(undefined, {minimumFractionDigits: 2});
                    item["trainingCostUSD"] = '' + Number(item["trainingCostUSD"]).toLocaleString(undefined, {minimumFractionDigits: 2});
                    item["trainingCostGBP"] = '' + Number(item["trainingCostGBP"]).toLocaleString(undefined, {minimumFractionDigits: 2});
                    item["trainingCostEUR"] = '' + Number(item["trainingCostEUR"]).toLocaleString(undefined, {minimumFractionDigits: 2});
                    item["adjustmentsCostCAD"] = '' + Number(item["adjustmentsCostCAD"]).toLocaleString(undefined, {minimumFractionDigits: 2});
                    item["adjustmentsCostUSD"] = '' + Number(item["adjustmentsCostUSD"]).toLocaleString(undefined, {minimumFractionDigits: 2});
                    item["adjustmentsCostGBP"] = '' + Number(item["adjustmentsCostGBP"]).toLocaleString(undefined, {minimumFractionDigits: 2});
                    item["adjustmentsCostEUR"] = '' + Number(item["adjustmentsCostEUR"]).toLocaleString(undefined, {minimumFractionDigits: 2});
                    item["name"] = brandData.brand;
                }
            }
            this.elementsList.setBrandCosts(responseParsed.brandsData);

            for (let brandsCommerceData of responseParsed.brandsCommerceData) {

                for (let item of brandsCommerceData.totalCosts) {
                    item["commissionCostCAD"] = '' + Number(item["commissionCostCAD"]).toLocaleString(undefined, {minimumFractionDigits: 2});
                    item["commissionCostUSD"] = '' + Number(item["commissionCostUSD"]).toLocaleString(undefined, {minimumFractionDigits: 2});
                    item["commissionCostGBP"] = '' + Number(item["commissionCostGBP"]).toLocaleString(undefined, {minimumFractionDigits: 2});
                    item["commissionCostEUR"] = '' + Number(item["commissionCostEUR"]).toLocaleString(undefined, {minimumFractionDigits: 2});
                    item["performanceCostCAD"] = '' + Number(item["performanceCostCAD"]).toLocaleString(undefined, {minimumFractionDigits: 2});
                    item["performanceCostUSD"] = '' + Number(item["performanceCostUSD"]).toLocaleString(undefined, {minimumFractionDigits: 2});
                    item["performanceCostGBP"] = '' + Number(item["performanceCostGBP"]).toLocaleString(undefined, {minimumFractionDigits: 2});
                    item["performanceCostEUR"] = '' + Number(item["performanceCostEUR"]).toLocaleString(undefined, {minimumFractionDigits: 2});
                    item["consultingBaseCostCAD"] = '' + Number(item["consultingBaseCostCAD"]).toLocaleString(undefined, {minimumFractionDigits: 2});
                    item["consultingBaseCostUSD"] = '' + Number(item["consultingBaseCostUSD"]).toLocaleString(undefined, {minimumFractionDigits: 2});
                    item["consultingBaseCostGBP"] = '' + Number(item["consultingBaseCostGBP"]).toLocaleString(undefined, {minimumFractionDigits: 2});
                    item["consultingBaseCostEUR"] = '' + Number(item["consultingBaseCostEUR"]).toLocaleString(undefined, {minimumFractionDigits: 2});
                    item["taxesCostCAD"] = '' + Number(item["taxesCostCAD"]).toLocaleString(undefined, {minimumFractionDigits: 2});
                    item["taxesCostUSD"] = '' + Number(item["taxesCostUSD"]).toLocaleString(undefined, {minimumFractionDigits: 2});
                    item["taxesCostGBP"] = '' + Number(item["taxesCostGBP"]).toLocaleString(undefined, {minimumFractionDigits: 2});
                    item["taxesCostEUR"] = '' + Number(item["taxesCostEUR"]).toLocaleString(undefined, {minimumFractionDigits: 2});
                    item["totalCostsCAD"] = '' + Number(item["totalCostsCAD"]).toLocaleString(undefined, {minimumFractionDigits: 2});
                    item["totalCostsUSD"] = '' + Number(item["totalCostsUSD"]).toLocaleString(undefined, {minimumFractionDigits: 2});
                    item["totalCostsGBP"] = '' + Number(item["totalCostsGBP"]).toLocaleString(undefined, {minimumFractionDigits: 2});
                    item["totalCostsEUR"] = '' + Number(item["totalCostsEUR"]).toLocaleString(undefined, {minimumFractionDigits: 2});
                    item["tipsCostCAD"] = '' + Number(item["tipsCostCAD"]).toLocaleString(undefined, {minimumFractionDigits: 2});
                    item["tipsCostUSD"] = '' + Number(item["tipsCostUSD"]).toLocaleString(undefined, {minimumFractionDigits: 2});
                    item["tipsCostGBP"] = '' + Number(item["tipsCostGBP"]).toLocaleString(undefined, {minimumFractionDigits: 2});
                    item["tipsCostEUR"] = '' + Number(item["tipsCostEUR"]).toLocaleString(undefined, {minimumFractionDigits: 2});
                    item["bonusCostCAD"] = '' + Number(item["bonusCostCAD"]).toLocaleString(undefined, {minimumFractionDigits: 2});
                    item["bonusCostUSD"] = '' + Number(item["bonusCostUSD"]).toLocaleString(undefined, {minimumFractionDigits: 2});
                    item["bonusCostGBP"] = '' + Number(item["bonusCostGBP"]).toLocaleString(undefined, {minimumFractionDigits: 2});
                    item["bonusCostEUR"] = '' + Number(item["bonusCostEUR"]).toLocaleString(undefined, {minimumFractionDigits: 2});
                    item["hostingCostCAD"] = '' + Number(item["hostingCostCAD"]).toLocaleString(undefined, {minimumFractionDigits: 2});
                    item["hostingCostUSD"] = '' + Number(item["hostingCostUSD"]).toLocaleString(undefined, {minimumFractionDigits: 2});
                    item["hostingCostGBP"] = '' + Number(item["hostingCostGBP"]).toLocaleString(undefined, {minimumFractionDigits: 2});
                    item["hostingCostEUR"] = '' + Number(item["hostingCostEUR"]).toLocaleString(undefined, {minimumFractionDigits: 2});
                    item["trainingCostCAD"] = '' + Number(item["trainingCostCAD"]).toLocaleString(undefined, {minimumFractionDigits: 2});
                    item["trainingCostUSD"] = '' + Number(item["trainingCostUSD"]).toLocaleString(undefined, {minimumFractionDigits: 2});
                    item["trainingCostGBP"] = '' + Number(item["trainingCostGBP"]).toLocaleString(undefined, {minimumFractionDigits: 2});
                    item["trainingCostEUR"] = '' + Number(item["trainingCostEUR"]).toLocaleString(undefined, {minimumFractionDigits: 2});
                    item["adjustmentsCostCAD"] = '' + Number(item["adjustmentsCostCAD"]).toLocaleString(undefined, {minimumFractionDigits: 2});
                    item["adjustmentsCostUSD"] = '' + Number(item["adjustmentsCostUSD"]).toLocaleString(undefined, {minimumFractionDigits: 2});
                    item["adjustmentsCostGBP"] = '' + Number(item["adjustmentsCostGBP"]).toLocaleString(undefined, {minimumFractionDigits: 2});
                    item["adjustmentsCostEUR"] = '' + Number(item["adjustmentsCostEUR"]).toLocaleString(undefined, {minimumFractionDigits: 2});
                    item["name"] = brandsCommerceData.brand;
                }
            }
            this.elementsList.setBrandsCommerceData(responseParsed.brandsCommerceData);
            this.elementsList.setTotalCostCAD('' + Number(totalCostCAD).toLocaleString(undefined, {minimumFractionDigits: 2}));
            this.elementsList.setTotalCostGBP('' + Number(totalCostGBP).toLocaleString(undefined, {minimumFractionDigits: 2}));
            this.elementsList.setTotalCostEUR('' + Number(totalCostEUR).toLocaleString(undefined, {minimumFractionDigits: 2}));
            this.elementsList.setTotalCostUSD('' + Number(totalCostUSD).toLocaleString(undefined, {minimumFractionDigits: 2}));
        }

        if(responseParsed.currentBalanceTransfers){
            this.elementsList.setBalanceTransfersCurrentPeriod(responseParsed.currentBalanceTransfers);
        }

        if(responseParsed.futureBalanceTransfers){
            this.elementsList.setBalanceTransfersNextPeriod(responseParsed.futureBalanceTransfers);
        }

        this.elementsList.setPaymentDateOptions(responseParsed.payments);
        this.elementsList.setIdPayment(responseParsed.idPayment);
    }

    protected filterMultipleSelectorOnChange(){

        this.filterList();
    }

    public exportToCSV(brandCosts: any, totalCostCAD: string, totalCostUSD: string, totalCostGBP: string, totalCostEUR: string, balanceTransfersCurrentPeriod: any, balanceTransfersNextPeriod: any) {
        let brandCSVData = [];
        brandCSVData.push({
            "Brand": "",
            "Account": "",
            "Total Cost": "CAD",
            " ": "USD",
            "  ": "GBP",
            "   ": "EUR",
            "Commission": "CAD",
            "    ": "USD",
            "     ": "GBP",
            "      ": "EUR",
            "Performance": "CAD",
            "       ": "USD",
            "        ": "GBP",
            "         ": "EUR",
            "Consulting Base": "CAD",
            "          ": "USD",
            "           ": "GBP",
            "            ": "EUR",
            "Bonuses": "CAD",
            "             ": "USD",
            "              ": "GBP",
            "               ": "EUR",
            "Tips": "CAD",
            "                ": "USD",
            "                 ": "GBP",
            "                  ": "EUR",
            "Hosting": "CAD",
            "                   ": "USD",
            "                    ": "GBP",
            "                     ": "EUR",
            "Training":"CAD",
            "                      ":"USD",
            "                       ": "GBP",
            "                        ": "EUR",
            "Adjustments":"CAD",
            "                         ":"USD",
            "                          ": "GBP",
            "                           ": "EUR",
        });
        for (let brandData of brandCosts) {
            for (let item of brandData.totalCosts) {
                brandCSVData.push({
                    "Brand": brandData.brand,
                    "Account": item["account"],
                    "Total Cost": item["totalCostsCAD"],
                    " ": item["totalCostsUSD"],
                    "  ": item["totalCostsGBP"],
                    "   ": item["totalCostsEUR"],
                    "Commission": item["commissionCostCAD"],
                    "    ": item["commissionCostUSD"],
                    "     ": item["commissionCostGBP"],
                    "      ": item["commissionCostEUR"],
                    "Performance": item["performanceCostCAD"],
                    "       ": item["performanceCostUSD"],
                    "        ": item["performanceCostGBP"],
                    "         ": item["performanceCostEUR"],
                    "Consulting Base": item["consultingBaseCostCAD"],
                    "          ": item["consultingBaseCostUSD"],
                    "           ": item["consultingBaseCostGBP"],
                    "            ": item["consultingBaseCostEUR"],
                    "Bonuses": item["bonusCostCAD"],
                    "             ": item["bonusCostUSD"],
                    "              ": item["bonusCostGBP"],
                    "               ": item["bonusCostEUR"],
                    "Tips": item["tipsCostCAD"],
                    "                ": item["tipsCostUSD"],
                    "                 ": item["tipsCostGBP"],
                    "                  ": item["tipsCostEUR"],
                    "Hosting": item["hostingCostCAD"],
                    "                   ": item["hostingCostUSD"],
                    "                    ": item["hostingCostGBP"],
                    "                     ": item["hostingCostEUR"],
                    "Training":item["trainingCostCAD"],
                    "                      ":item["trainingCostUSD"],
                    "                       ":item["trainingCostGBP"],
                    "                        ":item["trainingCostEUR"],
                    "Adjustments":item["adjustmentsCostCAD"],
                    "                         ":item["adjustmentsCostUSD"],
                    "                          ":item["adjustmentsCostGBP"],
                    "                           ":item["adjustmentsCostEUR"],
                });
            }
        }
        //push empty row
        brandCSVData.push({
            "Brand": "",
            "Account": "",
            "Total Cost": "",
            " ": "",
            "  ": "",
            "   ": "",
            "Commission": "",
            "    ": "",
            "     ": "",
            "      ": "",
            "Performance": "",
            "       ": "",
            "        ": "",
            "         ": "",
            "Consulting Base": "",
            "          ": "",
            "           ": "",
            "            ": "",
            "Bonuses": "",
            "             ": "",
            "              ": "",
            "               ": "",
            "Tips": "",
            "                ": "",
            "                 ": "",
            "                  ": "",
            "Hosting": "",
            "                   ": "",
            "                    ": "",
            "                     ": "",
            "Training":"",
            "                      ":"",
            "                       ":"",
            "                        ":"",
            "Adjustments":"",
            "                         ":"",
            "                          ":"",
            "                           ":"",
        });
        //Push Totals Row
        brandCSVData.push({
            "Brand": "TOTALS",
            "Account": "",
            "Total Cost": totalCostCAD,
            " ": totalCostUSD,
            "  ": totalCostGBP,
            "   ": totalCostEUR,
            "Commission": "",
            "    ": "",
            "     ": "",
            "      ": "",
            "Performance": "",
            "       ": "",
            "        ": "",
            "         ": "",
            "Consulting Base": "",
            "          ": "",
            "           ": "",
            "            ": "",
            "Bonuses": "",
            "             ": "",
            "              ": "",
            "               ": "",
            "Tips": "",
            "                ": "",
            "                 ": "",
            "                  ": "",
            "Hosting": "",
            "                   ": "",
            "                    ": "",
            "                     ": "",
            "Training":"",
            "                      ":"",
            "                       ":"",
            "                        ":"",
            "Adjustments":"",
            "                         ":"",
            "                          ":"",
            "                           ":"",
        });


        let balanceTransferData = [];

        for(let t of balanceTransfersCurrentPeriod){

            let r1 = [];
            r1["id"] = t["idUser"] + " Debits";
            r1["fullName"] = t["fullName"] + " Debits";
            r1["idCurrency"] = t["idCurrency"];
            r1["currentPeriodCAD"] =  t["totalDebitsCAD"];
            r1["currentPeriodUSD"] = t["totalDebitsUSD"];
            r1["currentPeriodGBP"] =  t["totalDebitsGBP"];
            r1["currentPeriodEUR"] = t["totalDebitsEUR"];
            r1["nextPeriodCAD"] = 0;
            r1["nextPeriodUSD"] = 0;
            r1["nextPeriodGBP"] = 0;
            r1["nextPeriodEUR"] = 0;
            balanceTransferData.push(r1);

            let r2 = [];
            r2["id"] = t["idUser"] + " Credits";
            r2["fullName"] = t["fullName"] + " Credits";
            r2["idCurrency"] = t["idCurrency"];
            r2["currentPeriodCAD"] =  t["totalCreditsCAD"];
            r2["currentPeriodUSD"] = t["totalCreditsUSD"];
            r2["currentPeriodGBP"] =  t["totalCreditsGBP"];
            r2["currentPeriodEUR"] = t["totalCreditsEUR"];
            r2["nextPeriodCAD"] = 0;
            r2["nextPeriodUSD"] = 0;
            r2["nextPeriodGBP"] = 0;
            r2["nextPeriodEUR"] = 0;
            balanceTransferData.push(r2);

        }

        for(let t of balanceTransfersNextPeriod){

            //check if user already exists
            let row1 = balanceTransferData.find(item => item.id === t["idUser"] + " Debits");
            if(row1){
                row1["nextPeriodCAD"] = t["totalDebitsCAD"];
                row1["nextPeriodUSD"] = t["totalDebitsUSD"];
                row1["nextPeriodGBP"] = t["totalDebitsGBP"];
                row1["nextPeriodEUR"] = t["totalDebitsEUR"];
            }else{
                let row1 = [];
                row1["id"] = t["idUser"] + " Debits";
                row1["fullName"] = t["fullName"] + " Debits";
                row1["idCurrency"] = t["idCurrency"];
                row1["currentPeriodCAD"] = 0;
                row1["currentPeriodUSD"] = 0;
                row1["currentPeriodGBP"] = 0;
                row1["currentPeriodEUR"] = 0;
                row1["nextPeriodCAD"] = t["totalDebitsCAD"];
                row1["nextPeriodUSD"] = t["totalDebitsUSD"];
                row1["nextPeriodGBP"] = t["totalDebitsGBP"];
                row1["nextPeriodEUR"] = t["totalDebitsEUR"];
                balanceTransferData.push(row1);

            }

            //check if user already exists
            let row2 = balanceTransferData.find(item => item.id === t["idUser"] + " Credits");
            if(row2){
                row2["nextPeriodCAD"] = t["totalCreditsCAD"];
                row2["nextPeriodUSD"] = t["totalCreditsUSD"];
                row2["nextPeriodGBP"] = t["totalCreditsGBP"];
                row2["nextPeriodEUR"] = t["totalCreditsEUR"];
            }else{
                let row2 = [];
                row2["id"] = t["idUser"] + " Credits";
                row2["fullName"] = t["fullName"] + " Credits";
                row2["idCurrency"] = t["idCurrency"];
                row2["currentPeriodCAD"] = 0;
                row2["currentPeriodUSD"] = 0;
                row2["currentPeriodGBP"] = 0;
                row2["currentPeriodEUR"] = 0;
                row2["nextPeriodCAD"] = t["totalCreditsCAD"];
                row2["nextPeriodUSD"] = t["totalCreditsUSD"];
                row2["nextPeriodGBP"] = t["totalCreditsGBP"];
                row2["nextPeriodEUR"] = t["totalCreditsEUR"];
                balanceTransferData.push(row2);

            }


        }

        if(balanceTransferData.length > 0){

            //Push Empty Row
            brandCSVData.push({
                "Brand": "",
                "Account": "",
                "Total Cost": "",
                " ": "",
                "  ": "",
                "   ": "",
                "Commission": "",
                "    ": "",
                "     ": "",
                "      ": "",
                "Performance": "",
                "       ": "",
                "        ": "",
                "         ": "",
                "Consulting Base": "",
                "          ": "",
                "           ": "",
                "            ": "",
                "Bonuses": "",
                "             ": "",
                "              ": "",
                "               ": "",
                "Tips": "",
                "                ": "",
                "                 ": "",
                "                  ": "",
                "Hosting": "",
                "                   ": "",
                "                    ": "",
                "                     ": "",
                "Training":"",
                "                      ":"",
                "                       ":"",
                "                        ":"",
                "Adjustments":"",
                "                         ":"",
                "                          ":"",
                "                           ":"",
            });

            let balanceTransferCSVData = [];

            //Push Heading Row
            balanceTransferCSVData.push({
                "Balance Transfers": "",
                " ": "",
                "CAD": "",
                "USD": "",
                "GBP": "",
                "EUR": "",
                "Beginning Balance": "",
                "Ending Balance": ""
            });

            let totalCADDebitsDifference = 0;
            let totalCADCreditsDifference = 0;
            let totalUSDDebitsDifference = 0;
            let totalUSDCreditsDifference = 0;
            let totalCADDifference = 0;
            let totalUSDDifference = 0;
            let totalGBPDebitsDifference = 0;
            let totalGBPCreditsDifference = 0;
            let totalEURDebitsDifference = 0;
            let totalEURCreditsDifference = 0;
            let totalGBPDifference = 0;
            let totalEURDifference = 0;
            let totalCurrentPeriodCreditsBalance = 0;
            let totalNextPeriodCreditsBalance = 0;
            let totalCurrentPeriodDebitsBalance = 0;
            let totalNextPeriodDebitsBalance = 0;
            let totalCurrentPeriodBalance = 0;
            let totalNextPeriodBalance = 0;


            for (let t of balanceTransferData) {
                let cadDifference = t["currentPeriodCAD"] - t["nextPeriodCAD"];
                let usdDifference = t["currentPeriodUSD"] - t["nextPeriodUSD"];
                let gbpDifference = t["currentPeriodGBP"] - t["nextPeriodGBP"];
                let eurDifference = t["currentPeriodEUR"] - t["nextPeriodEUR"];

                totalCADDifference += cadDifference;
                totalUSDDifference += usdDifference;
                totalGBPDifference += gbpDifference;
                totalEURDifference += eurDifference;

                let currentPeriodBalance = t["idCurrency"] == 1 ? t["currentPeriodUSD"] : t["currentPeriodCAD"];
                let nextPeriodBalance = t["idCurrency"] == 1 ? t["nextPeriodUSD"] : t["nextPeriodCAD"];

                totalCurrentPeriodBalance += Number(currentPeriodBalance);
                totalNextPeriodBalance += Number(nextPeriodBalance);

                if(t["id"].indexOf('Debits') !== -1 ){

                    totalCADDebitsDifference += cadDifference;
                    totalUSDDebitsDifference += usdDifference;
                    totalEURDebitsDifference += eurDifference;
                    totalGBPDebitsDifference += gbpDifference;

                    totalCurrentPeriodDebitsBalance += Number(currentPeriodBalance);
                    totalNextPeriodDebitsBalance += Number(nextPeriodBalance);

                }else{

                    totalCADCreditsDifference += cadDifference;
                    totalUSDCreditsDifference += usdDifference;
                    totalEURCreditsDifference += eurDifference;
                    totalGBPCreditsDifference += gbpDifference;
                    totalCurrentPeriodCreditsBalance += Number(currentPeriodBalance);
                    totalNextPeriodCreditsBalance += Number(nextPeriodBalance);
                }


                balanceTransferCSVData.push({
                    "Balance Transfers": t["fullName"],
                    " ": "",
                    "CAD": '' + Number(cadDifference).toLocaleString(undefined, {minimumFractionDigits: 2}),
                    "USD":'' + Number(usdDifference).toLocaleString(undefined, {minimumFractionDigits: 2}),
                    "GBP": '' + Number(gbpDifference).toLocaleString(undefined, {minimumFractionDigits: 2}),
                    "EUR":'' + Number(eurDifference).toLocaleString(undefined, {minimumFractionDigits: 2}),
                    "Beginning Balance": '' + Number(currentPeriodBalance).toLocaleString(undefined, {minimumFractionDigits: 2}),
                    "Ending Balance": '' + Number(nextPeriodBalance).toLocaleString(undefined, {minimumFractionDigits: 2}),
                });

            }

            //empty line
            balanceTransferCSVData.push({
                "Balance Transfers": "",
                " ": "",
                "CAD": "",
                "USD":"",
                "GBP": "",
                "EUR":"",
                "Beginning Balance": "",
                "Ending Balance": "",
            });

            //total debits line
            balanceTransferCSVData.push({
                "Balance Transfers": "Balance Transfer Debits",
                " ": "",
                "CAD": '' + Number(totalCADDebitsDifference).toLocaleString(undefined, {minimumFractionDigits: 2}),
                "USD":'' + Number(totalUSDDebitsDifference).toLocaleString(undefined, {minimumFractionDigits: 2}),
                "GBP": '' + Number(totalGBPDebitsDifference).toLocaleString(undefined, {minimumFractionDigits: 2}),
                "EUR":'' + Number(totalEURDebitsDifference).toLocaleString(undefined, {minimumFractionDigits: 2}),
                "Beginning Balance": '' + Number(totalCurrentPeriodDebitsBalance).toLocaleString(undefined, {minimumFractionDigits: 2}),
                "Ending Balance": '' + Number(totalNextPeriodDebitsBalance).toLocaleString(undefined, {minimumFractionDigits: 2}),
            });

            //total credits line
            balanceTransferCSVData.push({
                "Balance Transfers": "Balance Transfer Credits",
                " ": "",
                "CAD": '' + Number(totalCADCreditsDifference).toLocaleString(undefined, {minimumFractionDigits: 2}),
                "USD":'' + Number(totalUSDCreditsDifference).toLocaleString(undefined, {minimumFractionDigits: 2}),
                "GBP": '' + Number(totalGBPCreditsDifference).toLocaleString(undefined, {minimumFractionDigits: 2}),
                "EUR":'' + Number(totalUSDCreditsDifference).toLocaleString(undefined, {minimumFractionDigits: 2}),
                "Beginning Balance": '' + Number(totalCurrentPeriodCreditsBalance).toLocaleString(undefined, {minimumFractionDigits: 2}),
                "Ending Balance": '' + Number(totalNextPeriodCreditsBalance).toLocaleString(undefined, {minimumFractionDigits: 2}),
            });

            //total line
            balanceTransferCSVData.push({
                "Balance Transfers": "TOTAL Balance Transfers",
                " ": "",
                "CAD": '' + Number(totalCADDifference).toLocaleString(undefined, {minimumFractionDigits: 2}),
                "USD":'' + Number(totalUSDDifference).toLocaleString(undefined, {minimumFractionDigits: 2}),
                "GBP": '' + Number(totalGBPDifference).toLocaleString(undefined, {minimumFractionDigits: 2}),
                "EUR":'' + Number(totalEURDifference).toLocaleString(undefined, {minimumFractionDigits: 2}),
                "Beginning Balance": '' + Number(totalCurrentPeriodBalance).toLocaleString(undefined, {minimumFractionDigits: 2}),
                "Ending Balance": '' + Number(totalNextPeriodBalance).toLocaleString(undefined, {minimumFractionDigits: 2}),
            });

            downloadCSV({filename: "AccountingReport.csv", data: brandCSVData, data2: balanceTransferCSVData});
        }else{
            downloadCSV({filename: "AccountingReport.csv", data: brandCSVData});
        }
    }


    protected filterDropdownOnChange() {
        // on keywords filtering, always set the page back to 1.
        this.filterList();
    }

    private addTaxRow(fullName, taxTotal, province, taxCodes, userTaxCodes, csvData) {
        let row = '{"Name": "' + fullName + '","Total Tax": "' + taxTotal + '","Province": "' + province + '"';
        for (let code of taxCodes) {
            let userTaxCode = userTaxCodes.find(x => x.code == code);
            let userTaxNumber = userTaxCode != null ? userTaxCode.number : '';
            row += ',"' + code + '": "' + userTaxNumber + '"';
        }
        row += "}";
        csvData.push(JSON.parse(row));
    }


    protected onUpdateError(requestStatus: any, responseParsed): void {
        let msg = "error: while obtaining the data - (" + requestStatus + ")";
        this.viewModel.list.validationsList.setSingleMessage({field: "error", "label": requestStatus, message: msg});
        window.scrollTo(0, 0);
    }

    public exportCommerceToCSV(brandCosts: any, totalCostCAD: string, totalCostUSD: string, totalCostGBP: string, totalCostEUR: string, balanceTransfersCurrentPeriod: any, balanceTransfersNextPeriod: any) {
        let brandCSVData = [];
        brandCSVData.push({
            "Brand": "",
            "Account": "",
            "CommerceType": "",
            "Total Cost": "CAD",
            " ": "USD",
            "  ": "GBP",
            "   ": "EUR",
            "Commission": "CAD",
            "    ": "USD",
            "     ": "GBP",
            "      ": "EUR",
            "Performance": "CAD",
            "       ": "USD",
            "        ": "GBP",
            "         ": "EUR",
            "Consulting Base": "CAD",
            "          ": "USD",
            "           ": "GBP",
            "            ": "EUR",
            "Bonuses": "CAD",
            "             ": "USD",
            "              ": "GBP",
            "               ": "EUR",
            "Tips": "CAD",
            "                ": "USD",
            "                 ": "GBP",
            "                  ": "EUR",
            "Hosting": "CAD",
            "                   ": "USD",
            "                    ": "GBP",
            "                     ": "EUR",
            "Training":"CAD",
            "                      ":"USD",
            "                       ": "GBP",
            "                        ": "EUR",
            "Adjustments":"CAD",
            "                         ":"USD",
            "                          ": "GBP",
            "                           ": "EUR",
        });
        for (let brandData of brandCosts) {
            for (let item of brandData.totalCosts) {
                brandCSVData.push({
                    "Brand": brandData.brand,
                    "Account": item["account"],
                    "CommerceType": item["CommerceType"],
                    "Total Cost": item["totalCostsCAD"],
                    " ": item["totalCostsUSD"],
                    "  ": item["totalCostsGBP"],
                    "   ": item["totalCostsEUR"],
                    "Commission": item["commissionCostCAD"],
                    "    ": item["commissionCostUSD"],
                    "     ": item["commissionCostGBP"],
                    "      ": item["commissionCostEUR"],
                    "Performance": item["performanceCostCAD"],
                    "       ": item["performanceCostUSD"],
                    "        ": item["performanceCostGBP"],
                    "         ": item["performanceCostEUR"],
                    "Consulting Base": item["consultingBaseCostCAD"],
                    "          ": item["consultingBaseCostUSD"],
                    "           ": item["consultingBaseCostGBP"],
                    "            ": item["consultingBaseCostEUR"],
                    "Bonuses": item["bonusCostCAD"],
                    "             ": item["bonusCostUSD"],
                    "              ": item["bonusCostGBP"],
                    "               ": item["bonusCostEUR"],
                    "Tips": item["tipsCostCAD"],
                    "                ": item["tipsCostUSD"],
                    "                 ": item["tipsCostGBP"],
                    "                  ": item["tipsCostEUR"],
                    "Hosting": item["hostingCostCAD"],
                    "                   ": item["hostingCostUSD"],
                    "                    ": item["hostingCostGBP"],
                    "                     ": item["hostingCostEUR"],
                    "Training":item["trainingCostCAD"],
                    "                      ":item["trainingCostUSD"],
                    "                       ":item["trainingCostGBP"],
                    "                        ":item["trainingCostEUR"],
                    "Adjustments":item["adjustmentsCostCAD"],
                    "                         ":item["adjustmentsCostUSD"],
                    "                          ":item["adjustmentsCostGBP"],
                    "                           ":item["adjustmentsCostEUR"],
                });
            }
        }
        //push empty row
        brandCSVData.push({
            "Brand": "",
            "Account": "",
            "CommerceType": "",
            "Total Cost": "",
            " ": "",
            "  ": "",
            "   ": "",
            "Commission": "",
            "    ": "",
            "     ": "",
            "      ": "",
            "Performance": "",
            "       ": "",
            "        ": "",
            "         ": "",
            "Consulting Base": "",
            "          ": "",
            "           ": "",
            "            ": "",
            "Bonuses": "",
            "             ": "",
            "              ": "",
            "               ": "",
            "Tips": "",
            "                ": "",
            "                 ": "",
            "                  ": "",
            "Hosting": "",
            "                   ": "",
            "                    ": "",
            "                     ": "",
            "Training":"",
            "                      ":"",
            "                       ":"",
            "                        ":"",
            "Adjustments":"",
            "                         ":"",
            "                          ":"",
            "                           ":"",
        });
        //Push Totals Row
        brandCSVData.push({
            "Brand": "TOTALS",
            "Account": "",
            "CommerceType": "",
            "Total Cost": totalCostCAD,
            " ": totalCostUSD,
            "  ": totalCostGBP,
            "   ": totalCostEUR,
            "Commission": "",
            "    ": "",
            "     ": "",
            "      ": "",
            "Performance": "",
            "       ": "",
            "        ": "",
            "         ": "",
            "Consulting Base": "",
            "          ": "",
            "           ": "",
            "            ": "",
            "Bonuses": "",
            "             ": "",
            "              ": "",
            "               ": "",
            "Tips": "",
            "                ": "",
            "                 ": "",
            "                  ": "",
            "Hosting": "",
            "                   ": "",
            "                    ": "",
            "                     ": "",
            "Training":"",
            "                      ":"",
            "                       ":"",
            "                        ":"",
            "Adjustments":"",
            "                         ":"",
            "                          ":"",
            "                           ":"",
        });


        let balanceTransferData = [];

        for(let t of balanceTransfersCurrentPeriod){

            let r1 = [];
            r1["id"] = t["idUser"] + " Debits";
            r1["fullName"] = t["fullName"] + " Debits";
            r1["idCurrency"] = t["idCurrency"];
            r1["currentPeriodCAD"] =  t["totalDebitsCAD"];
            r1["currentPeriodUSD"] = t["totalDebitsUSD"];
            r1["currentPeriodGBP"] =  t["totalDebitsGBP"];
            r1["currentPeriodEUR"] = t["totalDebitsEUR"];
            r1["nextPeriodCAD"] = 0;
            r1["nextPeriodUSD"] = 0;
            r1["nextPeriodGBP"] = 0;
            r1["nextPeriodEUR"] = 0;
            balanceTransferData.push(r1);

            let r2 = [];
            r2["id"] = t["idUser"] + " Credits";
            r2["fullName"] = t["fullName"] + " Credits";
            r2["idCurrency"] = t["idCurrency"];
            r2["currentPeriodCAD"] =  t["totalCreditsCAD"];
            r2["currentPeriodUSD"] = t["totalCreditsUSD"];
            r2["currentPeriodGBP"] =  t["totalCreditsGBP"];
            r2["currentPeriodEUR"] = t["totalCreditsEUR"];
            r2["nextPeriodCAD"] = 0;
            r2["nextPeriodUSD"] = 0;
            r2["nextPeriodGBP"] = 0;
            r2["nextPeriodEUR"] = 0;
            balanceTransferData.push(r2);

        }

        for(let t of balanceTransfersNextPeriod){

            //check if user already exists
            let row1 = balanceTransferData.find(item => item.id === t["idUser"] + " Debits");
            if(row1){
                row1["nextPeriodCAD"] = t["totalDebitsCAD"];
                row1["nextPeriodUSD"] = t["totalDebitsUSD"];
                row1["nextPeriodGBP"] = t["totalDebitsGBP"];
                row1["nextPeriodEUR"] = t["totalDebitsEUR"];
            }else{
                let row1 = [];
                row1["id"] = t["idUser"] + " Debits";
                row1["fullName"] = t["fullName"] + " Debits";
                row1["idCurrency"] = t["idCurrency"];
                row1["currentPeriodCAD"] = 0;
                row1["currentPeriodUSD"] = 0;
                row1["currentPeriodGBP"] = 0;
                row1["currentPeriodEUR"] = 0;
                row1["nextPeriodCAD"] = t["totalDebitsCAD"];
                row1["nextPeriodUSD"] = t["totalDebitsUSD"];
                row1["nextPeriodGBP"] = t["totalDebitsGBP"];
                row1["nextPeriodEUR"] = t["totalDebitsEUR"];
                balanceTransferData.push(row1);

            }

            //check if user already exists
            let row2 = balanceTransferData.find(item => item.id === t["idUser"] + " Credits");
            if(row2){
                row2["nextPeriodCAD"] = t["totalCreditsCAD"];
                row2["nextPeriodUSD"] = t["totalCreditsUSD"];
                row2["nextPeriodGBP"] = t["totalCreditsGBP"];
                row2["nextPeriodEUR"] = t["totalCreditsEUR"];
            }else{
                let row2 = [];
                row2["id"] = t["idUser"] + " Credits";
                row2["fullName"] = t["fullName"] + " Credits";
                row2["idCurrency"] = t["idCurrency"];
                row2["currentPeriodCAD"] = 0;
                row2["currentPeriodUSD"] = 0;
                row2["currentPeriodGBP"] = 0;
                row2["currentPeriodEUR"] = 0;
                row2["nextPeriodCAD"] = t["totalCreditsCAD"];
                row2["nextPeriodUSD"] = t["totalCreditsUSD"];
                row2["nextPeriodGBP"] = t["totalCreditsGBP"];
                row2["nextPeriodEUR"] = t["totalCreditsEUR"];
                balanceTransferData.push(row2);

            }


        }

        if(balanceTransferData.length > 0){

            //Push Empty Row
            brandCSVData.push({
                "Brand": "",
                "Account": "",
                "CommerceType": "",
                "Total Cost": "",
                " ": "",
                "  ": "",
                "   ": "",
                "Commission": "",
                "    ": "",
                "     ": "",
                "      ": "",
                "Performance": "",
                "       ": "",
                "        ": "",
                "         ": "",
                "Consulting Base": "",
                "          ": "",
                "           ": "",
                "            ": "",
                "Bonuses": "",
                "             ": "",
                "              ": "",
                "               ": "",
                "Tips": "",
                "                ": "",
                "                 ": "",
                "                  ": "",
                "Hosting": "",
                "                   ": "",
                "                    ": "",
                "                     ": "",
                "Training":"",
                "                      ":"",
                "                       ":"",
                "                        ":"",
                "Adjustments":"",
                "                         ":"",
                "                          ":"",
                "                           ":"",
            });

            let balanceTransferCSVData = [];

            //Push Heading Row
            balanceTransferCSVData.push({
                "Balance Transfers": "",
                " ": "",
                "CAD": "",
                "USD": "",
                "GBP": "",
                "EUR": "",
                "Beginning Balance": "",
                "Ending Balance": ""
            });

            let totalCADDebitsDifference = 0;
            let totalCADCreditsDifference = 0;
            let totalUSDDebitsDifference = 0;
            let totalUSDCreditsDifference = 0;
            let totalCADDifference = 0;
            let totalUSDDifference = 0;
            let totalGBPDebitsDifference = 0;
            let totalGBPCreditsDifference = 0;
            let totalEURDebitsDifference = 0;
            let totalEURCreditsDifference = 0;
            let totalGBPDifference = 0;
            let totalEURDifference = 0;
            let totalCurrentPeriodCreditsBalance = 0;
            let totalNextPeriodCreditsBalance = 0;
            let totalCurrentPeriodDebitsBalance = 0;
            let totalNextPeriodDebitsBalance = 0;
            let totalCurrentPeriodBalance = 0;
            let totalNextPeriodBalance = 0;


            for (let t of balanceTransferData) {
                let cadDifference = t["currentPeriodCAD"] - t["nextPeriodCAD"];
                let usdDifference = t["currentPeriodUSD"] - t["nextPeriodUSD"];
                let gbpDifference = t["currentPeriodGBP"] - t["nextPeriodGBP"];
                let eurDifference = t["currentPeriodEUR"] - t["nextPeriodEUR"];

                totalCADDifference += cadDifference;
                totalUSDDifference += usdDifference;
                totalGBPDifference += gbpDifference;
                totalEURDifference += eurDifference;

                let currentPeriodBalance = t["idCurrency"] == 1 ? t["currentPeriodUSD"] : t["currentPeriodCAD"];
                let nextPeriodBalance = t["idCurrency"] == 1 ? t["nextPeriodUSD"] : t["nextPeriodCAD"];

                totalCurrentPeriodBalance += Number(currentPeriodBalance);
                totalNextPeriodBalance += Number(nextPeriodBalance);

                if(t["id"].indexOf('Debits') !== -1 ){

                    totalCADDebitsDifference += cadDifference;
                    totalUSDDebitsDifference += usdDifference;
                    totalEURDebitsDifference += eurDifference;
                    totalGBPDebitsDifference += gbpDifference;

                    totalCurrentPeriodDebitsBalance += Number(currentPeriodBalance);
                    totalNextPeriodDebitsBalance += Number(nextPeriodBalance);

                }else{

                    totalCADCreditsDifference += cadDifference;
                    totalUSDCreditsDifference += usdDifference;
                    totalEURCreditsDifference += eurDifference;
                    totalGBPCreditsDifference += gbpDifference;
                    totalCurrentPeriodCreditsBalance += Number(currentPeriodBalance);
                    totalNextPeriodCreditsBalance += Number(nextPeriodBalance);
                }


                balanceTransferCSVData.push({
                    "Balance Transfers": t["fullName"],
                    " ": "",
                    "CAD": '' + Number(cadDifference).toLocaleString(undefined, {minimumFractionDigits: 2}),
                    "USD":'' + Number(usdDifference).toLocaleString(undefined, {minimumFractionDigits: 2}),
                    "GBP": '' + Number(gbpDifference).toLocaleString(undefined, {minimumFractionDigits: 2}),
                    "EUR":'' + Number(eurDifference).toLocaleString(undefined, {minimumFractionDigits: 2}),
                    "Beginning Balance": '' + Number(currentPeriodBalance).toLocaleString(undefined, {minimumFractionDigits: 2}),
                    "Ending Balance": '' + Number(nextPeriodBalance).toLocaleString(undefined, {minimumFractionDigits: 2}),
                });

            }

            //empty line
            balanceTransferCSVData.push({
                "Balance Transfers": "",
                " ": "",
                "CAD": "",
                "USD":"",
                "GBP": "",
                "EUR":"",
                "Beginning Balance": "",
                "Ending Balance": "",
            });

            //total debits line
            balanceTransferCSVData.push({
                "Balance Transfers": "Balance Transfer Debits",
                " ": "",
                "CAD": '' + Number(totalCADDebitsDifference).toLocaleString(undefined, {minimumFractionDigits: 2}),
                "USD":'' + Number(totalUSDDebitsDifference).toLocaleString(undefined, {minimumFractionDigits: 2}),
                "GBP": '' + Number(totalGBPDebitsDifference).toLocaleString(undefined, {minimumFractionDigits: 2}),
                "EUR":'' + Number(totalEURDebitsDifference).toLocaleString(undefined, {minimumFractionDigits: 2}),
                "Beginning Balance": '' + Number(totalCurrentPeriodDebitsBalance).toLocaleString(undefined, {minimumFractionDigits: 2}),
                "Ending Balance": '' + Number(totalNextPeriodDebitsBalance).toLocaleString(undefined, {minimumFractionDigits: 2}),
            });

            //total credits line
            balanceTransferCSVData.push({
                "Balance Transfers": "Balance Transfer Credits",
                " ": "",
                "CAD": '' + Number(totalCADCreditsDifference).toLocaleString(undefined, {minimumFractionDigits: 2}),
                "USD":'' + Number(totalUSDCreditsDifference).toLocaleString(undefined, {minimumFractionDigits: 2}),
                "GBP": '' + Number(totalGBPCreditsDifference).toLocaleString(undefined, {minimumFractionDigits: 2}),
                "EUR":'' + Number(totalUSDCreditsDifference).toLocaleString(undefined, {minimumFractionDigits: 2}),
                "Beginning Balance": '' + Number(totalCurrentPeriodCreditsBalance).toLocaleString(undefined, {minimumFractionDigits: 2}),
                "Ending Balance": '' + Number(totalNextPeriodCreditsBalance).toLocaleString(undefined, {minimumFractionDigits: 2}),
            });

            //total line
            balanceTransferCSVData.push({
                "Balance Transfers": "TOTAL Balance Transfers",
                " ": "",
                "CAD": '' + Number(totalCADDifference).toLocaleString(undefined, {minimumFractionDigits: 2}),
                "USD":'' + Number(totalUSDDifference).toLocaleString(undefined, {minimumFractionDigits: 2}),
                "GBP": '' + Number(totalGBPDifference).toLocaleString(undefined, {minimumFractionDigits: 2}),
                "EUR":'' + Number(totalEURDifference).toLocaleString(undefined, {minimumFractionDigits: 2}),
                "Beginning Balance": '' + Number(totalCurrentPeriodBalance).toLocaleString(undefined, {minimumFractionDigits: 2}),
                "Ending Balance": '' + Number(totalNextPeriodBalance).toLocaleString(undefined, {minimumFractionDigits: 2}),
            });

            downloadCSV({filename: "AccountingReportCommerceSplit.csv", data: brandCSVData, data2: balanceTransferCSVData});
        }else{
            downloadCSV({filename: "AccountingReportCommerceSplit.csv", data: brandCSVData});
        }
    }

    protected exportBalanceTransferToCSV() {

        // LOADING : starts
        this.elementsList.builtTemplate.classList.add("loading");

        if( this.XHRHdl ){
            this.XHRHdl.cancelAndReset();
        }

        let subViewModel = {
            filterPayment: {
                payment: this.viewModel.list.idPayment
            }
        };
        let usrReq_url: string;

        usrReq_url = '/api/valnet/payment/accounting/report/getBalanceTransfer';

        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)] );
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url,usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onGetBalanceTransferReturn;
        this.XHRHdl.execute();

    }


    protected onGetBalanceTransferReturn(req, obj){

        return function(){

            if (req.request.readyState == 4) {

                let responseParsed = JSON.parse(req.request.response);

                if(  req.request.status == 200  ){

                    downloadCSV({filename: 'BalanceTransfer.csv', data: responseParsed.data.balanceTransfer})
                }

                // LOADING : ends
                obj.elementsList.builtTemplate.classList.remove("loading");
            }
        }
    }

}



// WEBPACK FOOTER //
// ./js/modules/accounting_report_by_account.ts